import { render } from "./TheProfessionalResources.vue?vue&type=template&id=3a523804&scoped=true&ts=true"
import script from "./TheProfessionalResources.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalResources.vue?vue&type=script&lang=ts"

import "./TheProfessionalResources.vue?vue&type=style&index=0&id=3a523804&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a523804"]])

export default __exports__